export class AuthError extends Error {
  public readonly code: string;

  constructor(authErrorData: { code: string; message: string }) {
    super(authErrorData.message);

    this.code = authErrorData.code;
    this.name = 'AuthError';

    const ErrorCtor = Error as unknown as { captureStackTrace?: (target: object, constructor: unknown) => void };
    if (ErrorCtor.captureStackTrace) {
      ErrorCtor.captureStackTrace(this, AuthError);
    }
  }
}
